/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey }) {
    const url = searchKey ? `${this.url}?search=${searchKey}` : this.url;
    return axios.get(url);
  }

  // Upload a single attachment file and return signed_id
  uploadAttachment(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/upload_attachment`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  }
}

export default new CannedResponse();

